export default "__VITE_ASSET__BZIY9Dcq__"